import {useId} from "react";
import {makeStyles} from "tss-react/mui";
import {Box, TextField, TextFieldProps, Typography} from "@mui/material";
import {AdminFieldContainer, IProps as AdminFieldContainerProps} from "@/pages/ManagerView/ContentCreation/AdminFieldContainer";

export type IProps = Omit<AdminFieldContainerProps, "children"> & Omit<TextFieldProps, "className" | "error" | "variant"> & {
	className?: string;
	error?: string;
	/** Default `inset`: label on the outline. `above`: label above the field (no notch). */
	labelPlacement?: "inset" | "above";
};


const useStyles = makeStyles()((_theme) => ({
	adminInputText: {

	},
	textField: {
		width: "100%"
	}
}));

export const AdminInputText = ({
	children,
	required,
	error,
	outline,
	className,
	labelPlacement = "inset",
	InputLabelProps: inputLabelPropsFromProps,
	label,
	id,
	...textFieldProps
}: IProps): JSX.Element => {
	const {cx, classes} = useStyles();
	const isAbove = labelPlacement === "above";
	const autoId = useId();
	const aboveFieldId = (id ?? autoId) as string;

	return (
		<Box className={cx(classes.adminInputText, className)}>
			<AdminFieldContainer error={error} required={required} outline={outline}>
				{isAbove && label != null && label !== "" ? (
					<>
						<Typography
							component="label"
							htmlFor={aboveFieldId}
							sx={(theme) => ({
								display: "block",
								fontWeight: 600,
								marginBottom: theme.spacing(1),
								"& .req": {color: theme.palette.error.main}
							})}
						>
							{label}
							{required ? <span className="req"> *</span> : null}
						</Typography>
						<TextField
							id={aboveFieldId}
							error={!!error}
							required={false}
							className={classes.textField}
							variant="outlined"
							hiddenLabel
							{...textFieldProps}
						/>
					</>
				) : (
					<TextField
						id={id}
						error={!!error}
						required={required}
						className={classes.textField}
						variant="outlined"
						label={label}
						InputLabelProps={{
							shrink: true,
							...(required && {
								sx: {"& .MuiFormLabel-asterisk": {color: "error.main"}}
							}),
							...inputLabelPropsFromProps
						}}
						{...textFieldProps}
					/>
				)}
			</AdminFieldContainer>
			{children}
		</Box>
	);
};